export default {
  path: '/printing_surface_materials',
  name: 'printing_surface_materials',
  component: () => import('../components/printingsurfacematerial/Layout'),
  redirect: { name: 'PrintingSurfaceMaterialList' },
  meta: {
    breadcrumb: 'profile.printingsurface.materials',
  },
  children: [
    {
      name: 'PrintingSurfaceMaterialList',
      path: '',
      component: () => import('../views/printingsurfacematerial/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'PrintingSurfaceMaterialCreate',
      path: 'new',
      component: () => import('../views/printingsurfacematerial/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'PrintingSurfaceMaterialUpdate',
      path: ':id/edit',
      component: () => import('../views/printingsurfacematerial/Update'),
      meta: {
        breadcrumb: 'profile.printingsurface.material',
      },
    },
    {
      name: 'PrintingSurfaceMaterialShow',
      path: ':id',
      component: () => import('../views/printingsurfacematerial/Show'),
      meta: {
        breadcrumb: 'profile.printingsurface.material',
      },
    }
  ]
};
